(function () {
  'use strict';

  function bindCta(box) {
    if (box.dataset.nsBound === '1') return;
    box.dataset.nsBound = '1';
    var toggle = box.querySelector('[data-ns-cta-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var open = box.getAttribute('data-ns-open') === 'true';
      box.setAttribute('data-ns-open', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-ns-cta]').forEach(bindCta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Shopify editor rebinds
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  var hero = document.querySelector('.ns-section--hero');
  var staggerCanvases = document.querySelectorAll('.ns-stagger-pair__canvas');
  var staggerTrioCanvases = document.querySelectorAll('.ns-stagger-trio__canvas');

  function updateHeroState() {
    if (!hero) return;
    var rect = hero.getBoundingClientRect();
    var headerEl = document.querySelector('.header:has(.header__groups), sticky-header, .header-wrapper, header');
    var threshold = headerEl ? Math.max(headerEl.offsetHeight, 60) : 60;
    if (rect.bottom <= threshold) {
      document.body.classList.add('ns-past-hero');
    } else {
      document.body.classList.remove('ns-past-hero');
    }
  }

  // ==========================================================================
  // スクロールに応じたセクション・要素のフェードイン (上下スクロールで何度でも再発火)
  // ==========================================================================
  var revealTargets = document.querySelectorAll(
    '.ns-section:not(.ns-section--hero):not(.ns-section--triple-grid):not(.ns-section--color-reveal), .ns-color-reveal__box, .ns-triple-grid__canvas, .ns-triple-grid__band'
  );
  if ('IntersectionObserver' in window) {
    var isMobile = window.innerWidth <= 768;
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ns-visible');
        } else {
          // 画面外に出たらリセットし、下から上に戻って再度スクロールした際にも再びフェードインさせる
          entry.target.classList.remove('ns-visible');
        }
      });
    }, {
      rootMargin: isMobile ? '0px 0px -15px 0px' : '0px 0px -30px 0px',
      threshold: 0.05
    });

    revealTargets.forEach(function (target) {
      sectionObserver.observe(target);
    });
  } else {
    revealTargets.forEach(function (target) {
      target.classList.add('ns-visible');
    });
  }

  // ==========================================================================
  // パララックス: 一時的にコメントアウト (フェードイン演出のみ有効)
  // ==========================================================================
  /*
  var parallaxItems = [];

  function initParallaxItems() {
    parallaxItems = [];
    var isMobile = window.innerWidth <= 768;

    // Stagger Pair: 右側の画像（上へせり上がる）
    document.querySelectorAll('.ns-stagger-pair__canvas').forEach(function (canvas) {
      var el = canvas.querySelector('.ns-stagger-pair__right');
      if (el) {
        parallaxItems.push({
          canvas: canvas,
          el: el,
          currentY: 0,
          targetY: 0,
          maxShift: isMobile ? 200 : 360,
          factor: 0.055
        });
      }
    });

    // Stagger Trio: B と C の画像（それぞれ異なるディレイで上へせり上がる）
    document.querySelectorAll('.ns-stagger-trio__canvas').forEach(function (canvas) {
      var itemB = canvas.querySelector('.ns-stagger-trio__b');
      if (itemB) {
        parallaxItems.push({
          canvas: canvas,
          el: itemB,
          currentY: 0,
          targetY: 0,
          maxShift: isMobile ? 150 : 260,
          factor: 0.06
        });
      }
      var itemC = canvas.querySelector('.ns-stagger-trio__c');
      if (itemC) {
        parallaxItems.push({
          canvas: canvas,
          el: itemC,
          currentY: 0,
          targetY: 0,
          maxShift: isMobile ? 220 : 380,
          factor: 0.05
        });
      }
    });
  }

  initParallaxItems();

  var rafId = null;

  function updateParallaxTargets() {
    var vh = window.innerHeight;
    parallaxItems.forEach(function (item) {
      var rect = item.canvas.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < vh) {
        var progress = (vh - rect.top) / (vh + rect.height);
        item.targetY = -(progress - 0.5) * item.maxShift;
      }
    });
  }

  function renderParallaxLoop() {
    var stillMoving = false;
    parallaxItems.forEach(function (item) {
      var diff = item.targetY - item.currentY;
      if (Math.abs(diff) > 0.05) {
        item.currentY += diff * item.factor;
        item.el.style.transform = 'translate3d(0, ' + item.currentY.toFixed(2) + 'px, 0)';
        stillMoving = true;
      } else if (item.currentY !== item.targetY) {
        item.currentY = item.targetY;
        item.el.style.transform = 'translate3d(0, ' + item.currentY.toFixed(2) + 'px, 0)';
      }
    });

    if (stillMoving) {
      rafId = requestAnimationFrame(renderParallaxLoop);
    } else {
      rafId = null;
    }
  }

  function triggerParallax() {
    updateParallaxTargets();
    if (!rafId) {
      rafId = requestAnimationFrame(renderParallaxLoop);
    }
  }
  */

  var ticking = false;
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        updateHeroState();
        ticking = false;
      });
    }
    // triggerParallax();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    // initParallaxItems();
    onScroll();
  }, { passive: true });
  onScroll();

  if (hero) {
    var observer = new IntersectionObserver(function () {
      onScroll();
    }, { rootMargin: '-60px 0px 0px 0px', threshold: 0 });
    observer.observe(hero);
  }
});
